import { useSnackbar } from '@shared/snackbar';
import { useState } from 'react';

import { ExamAssigningLoadingModal, ExamAssigningResultModal } from '../../components';
import { useExamDistributionByMonth } from '../../providers';
import { ExamAssigningFormModal } from '../exam-assigning-form-modal';

interface ExamAssigningModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ExamAssigningModal(props: Readonly<ExamAssigningModalProps>) {
  const { open: isOpen, onClose } = props;

  const { showSnackbar } = useSnackbar();
  const [examAssigningResults, setExamAssigningResults] = useState<
    | {
        examCoursesChosen: number;
        examEventsAssigned: number;
      }
    | undefined
  >(undefined);
  const { assignExamsByExamCourseCodesAndMonthOfYear, isAssigningExams } =
    useExamDistributionByMonth();
  const [assigningState, setAssigningState] = useState<'assign' | 'success'>('assign');

  const onAssignExams = async (examCourseCodes: string[]) => {
    await assignExamsByExamCourseCodesAndMonthOfYear(examCourseCodes, {
      onCompleted: (data) => {
        if (!data?.ecAssignExamsByExamCourseCodesAndMonthOfYear) {
          throw new Error('No data returned from assign exams mutation');
        }
        setExamAssigningResults({
          examCoursesChosen: data.ecAssignExamsByExamCourseCodesAndMonthOfYear.examCoursesChosen,
          examEventsAssigned: data.ecAssignExamsByExamCourseCodesAndMonthOfYear.examEventsAssigned,
        });
        setAssigningState('success');
        showSnackbar({
          message: 'มอบหมายชุดข้อสอบเรียบร้อยแล้ว',
          variant: 'success',
        });
      },
      onError: () => {
        showSnackbar({
          message: 'ไม่สามารถมอบหมายชุดข้อสอบได้ กรุณาลองใหม่อีกครั้ง',
          variant: 'error',
        });
        setAssigningState('assign');
        onClose();
      },
    });
  };

  if (isAssigningExams) {
    return <ExamAssigningLoadingModal />;
  } else if (assigningState === 'assign') {
    return <ExamAssigningFormModal open={isOpen} onClose={onClose} onAssignExams={onAssignExams} />;
  } else if (assigningState === 'success') {
    return (
      <ExamAssigningResultModal open={isOpen} onClose={onClose} results={examAssigningResults} />
    );
  }

  return null;
}
